/**
 /* Safely renders arbitrary third‑party HTML in React.
 * Handle Special cases of integrations (Hubspot, Termly, Tock) to ensure they will re-render after nagivating within an SPA app.
 */

import React, { useEffect, useRef, useState } from "react"
import PropTypes from "prop-types"
import Box from "../Box"

import {
  cleanTermly,
  reExecuteScripts,
  extractTockSlug,
  hardReloadTock,
} from "./utils"

const CustomHTML = ({ html, ...boxProps }) => {
  const containerRef = useRef(null)

  // Creating a unique id for HubSpot’s forms.create({ target })
  const [containerId] = useState(
    () => "custom-html-" + Math.random().toString(36).slice(2, 11)
  )

  useEffect(() => {
    const root = containerRef.current
    if (!root) return

    // Removing Termly markup and loader left from previous page
    cleanTermly(root)

    // Giving a unique container id. Needed for HubSpot forms to work correctly
    root.id = containerId

    // Parse HTML string into real DOM nodes
    const fragment = document.createRange().createContextualFragment(html)

    // Force every <script> inside to run again
    reExecuteScripts(fragment)

    // Replace previous snippet to avoid duplicates
    root.innerHTML = ""
    root.appendChild(fragment)

    // manually trigger Tock after DOM element is in place
    const slug = extractTockSlug(html)

    if (slug) {
      hardReloadTock(slug)
    }
  }, [html, containerId])

  return (
    <Box position="relative" {...boxProps}>
      <Box
        ref={containerRef}
        className="custom-html"
        dangerouslySetInnerHTML={{ __html: html }}
        suppressHydrationWarning
      />
    </Box>
  )
}

CustomHTML.propTypes = {
  html: PropTypes.string,
  ...Box.propTypes,
}

export default CustomHTML
